import axios from '@/plugins/axios'

class ConnectionService {
  // 커넥션 리스트 조회
  async getConnectionList(type) {
    const { data } = await axios.get('/sum/api/connections?type=' + type)
    return data
  }

  // 커넥션 정보 조회
  async getConnectionBrief(param) {
    const { data } = await axios.get('/sum/api/connections/' + param)
    return data
  }

  // 커넥션 초대 취소
  // connectionSeqId
  async deleteCon(param) {
    const { data } = await axios.delete('/sum/api/connections/invite/' + param)
    return data
  }

  // 커넥션 초대 거절
  // connectionSeqId
  async rejectCon(param) {
    const { data } = await axios.delete('/sum/api/connections/reject/' + param)
    return data
  }

  // 커넥션 입장
  // connectionSeqId
  async acceptCon(param) {
    const { data } = await axios.post('/sum/api/connections/' + param, '')
    return data
  }

  // 커넥션 정보 수정
  async putCon(param) {
    const formData = new FormData()
    formData.append('type', param.type)

    const { data } = await axios.put(
      '/sum/api/connections/' + param.connectionSeqId,
      formData
    )
    return data
  }

  // 커넥션 삭제
  async disConnected(param) {
    const { data } = await axios.delete(
      '/sum/api/connections?connectionSeqIdList=' + param
    )
    return data
  }

  // 이메일 초대
  async inviteCon(param) {
    const formData = new FormData()
    formData.append('userIdList', param.userIdList)
    formData.append('type', 'connection')

    const { data } = await axios.post('/sum/api/email/invite', formData)
    return data
  }

  // 커넥션 디테일 조회
  async getConnectionDetail(param) {
    const { data } = await axios.get('/sum/api/connections/detail/' + param)
    return data
  }

  // QR Code 생성
  async getQrCode() {
    const { data } = await axios.get('/sum/api/qr/createQR')
    return data
  }

  // QR Code 초대
  async inviteFromQRcode(userCode) {
    const { data } = await axios.post(`/sum/api/qr/invite/${userCode}`, null)
    return data
  }

  // Connection brief 공유
  async shareMyConnBrief(connectionSeqId) {
    const { data } = await axios.post(
      `/sum/api/report/share/together/${connectionSeqId}`
    )
    return data
  }

  // Connection brief 공유 정보 가져오기
  async getShareConnBrief(code) {
    const { data } = await axios.get(`/sum/api/report/share/together/${code}`)
    return data
  }
}

export default new ConnectionService()
